<div class="mb-3 p-4 border border-gray-200 rounded-lg bg-white shadow-sm" [class.hidden]="!showFilters">
    <dtype-component-list class="w-full" [dtypeForm]="filterDTypeForm" [isUpdate]="true">
    </dtype-component-list>

    <!-- Action buttons -->
    <div class="gap-2 flex mt-4 px-2 pb-2 w-full">

        <!-- Clear button -->
        <button mat-stroked-button color="warn" (click)="clearFilter()">
            {{ 'clearFilter' | transloco }}
        </button>
    </div>
</div>